import React, { useState } from "react";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { Button, message } from "antd";
import { useAppModel } from "../appModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const DataBox = () => {
    const { selectedRowKeys, setDrawerVisible, syncData } = useAppModel();
    const [syncLoading, setSyncLoading] = useState<boolean>(false);

    const onOpenDrawer = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            setDrawerVisible(true);
        } else {
            message.error("请选择记录!");
        }
    }

    const action = (
        <>
            <YhAuth resCode={ResourceAuthEnum.DATA_APP_VW}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onOpenDrawer}
                >查看</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.DATA_APP_SYNC}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    loading={syncLoading}
                    onClick={() => {
                        setSyncLoading(true);
                        syncData().then(res => setSyncLoading(false)).catch(err => setSyncLoading(false));
                    }}
                >{syncLoading ? "同步中" : "同步"}</Button>
            </YhAuth>
        </>
    );

    return (
        <YhBox title=" " action={action}>
            <DataTable />
        </YhBox>
    )
}